var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum1Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "#1167ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8135 22.5V20.715H15.1985V13.695H13.1885V12.33C14.2985 12.12 15.0635 11.835 15.7685 11.385H17.4035V20.715H19.4885V22.5H12.8135Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum1Blue);
export default __webpack_public_path__ + "static/media/icon_circleNum_1_blue.c7d7671220049a82fe45326507dd22b4.svg";
export { ForwardRef as ReactComponent };